import React, {Component} from 'react';
import axios from "../../../../axios/axios_visitortag";
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {message, Spin} from 'antd'
import Files from "react-files";
import {Button as SementicBtn, Icon} from "semantic-ui-react";
import * as actionCreator from "../../../../store/Action";
import './Offline.scss'
import csvFormat from '../../../../assets/csv/csv_format_01.csv'
import Cookies from "js-cookie";
import base64 from "base-64";
import {connect} from "react-redux";
import {Col, Row} from "reactstrap";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import * as common from "../../../../const/Common/CommonFunc";
import * as util from "../../../../util/Validator";
import apiConfig from "../../../../axios/axios_api_services";

class App extends Component {
  state = {
    file: [],
    json: [],
    errorjson: [],
    errortable: false,
  };
  onFilesChange = name => files => {
    if (files.length !== 0) {
      this.onFileChange(name, files[0]);
    } else {
      message.error("Please choose valid file type!");
    }
  };
  onFileChange = async (name, e) => {
    const textDataUrl = await readFile(e);
    this.setState({
      isSpin: false,
      [name]: textDataUrl,
      errorjson: [],
      json: this.base64Decode(textDataUrl, "CSV")
    });
  };
  base64Decode = (bytes, file) => {
    try {
      let split = bytes.split("base64,");
      let decode = base64.decode(split[1]);
      return this.csvToJson(decode);
    } catch (e) {
      console.log("exception", e);
      message.error("Please select " + file + " file!");
    }
  };
  csvToJson = (csv) => {
    try{
      this.setState({isSpin: true});
      let lines = csv.split("\n");
      let result = [];

      let headers = ["hostAMobile", "hostBMobile", "buildingName", "floorName", "visitorPassNumber", "visitingPurpose", "visitorIdentificationNumber", "visitorFirstName", "visitorLastName", "visitorTitle", "visitorEmail", "visitorMobile", "visitorCompanyName", "checkInDate", "checkOutDate", "refNo"];
      for (let i = 1; i < lines.length; i++) {
        let obj = {};
        let currentline = lines[i].split(",");
        if (currentline.length > 1) {
          for (let j = 0; j < headers.length; j++) {
            let value = currentline[j].trim();
            if (value.toString() === "") {
              value = "";
            }
            obj[headers[j]] = value;
          }

          if (obj.hostBMobile !== undefined) {
            result.push(obj);
          }
        }
      }
      if (result.length === 0) {
        common.notifyMessage("Empty file!")
      }
      return result;
    }catch(error){
      common.notifyMessage("Invalid file!");
      return [];
    }
  };
  removeData = () => {
    swal({
      title: "Do you want to remove this data?",
      icon: are_you_sure_icon,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.setState({
              json: [],
              errorjson: [],
            });
            break;
          default:
        }
      });
  };
  submit = () => {
    let json = this.state.json;

    let condition = true;
    let errorsList = [];

    if (json.length !== 0) {
      json.map((obj, index) => {

        if (obj.buildingName.trim() === "" || obj.floorName.trim() === "" || obj.visitorPassNumber.trim() === "" || obj.visitingPurpose.trim() === "" || obj.visitorIdentificationNumber.trim() === "" || obj.visitorFirstName.trim() === "" || obj.visitorLastName.trim() === "" || obj.visitorTitle.trim() === "" || obj.visitorMobile.trim() === "" || obj.checkInDate.trim() === "") {
          condition = false;
        }
        if (!util.identityValueValidator(obj.visitorIdentificationNumber, "ALL", "NOT_WARNING")) {

          errorsList.push({
            row: (index + 1),
            message: "Invalid identification number",
          });
          // common.notifyMessage("Invalid identification number. Row number = " + (index + 1));
        }
      })
    } else {
      common.warningAlert("File not detected!", 1);
      return;
    }


    if (condition) {
      if (errorsList.length === 0) {

        const obj = {bulks: this.state.json};
        this.props.spinnerHandler(true);

        const headers = {
          "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
        };

        let corporateId = this.props.usr_obj.corporates[0].corporateId;

        axios.put(apiConfig.CORPORATE_OFFLINE_BULK(corporateId), obj, {headers: headers})
          .then(response => {
            if (response.data.success) {
              common.notifyMessage(response.data.message, 2);
              this.setState({
                json: []
              });

            } else {
              common.notifyMessage(response.data.message);
              this.setState({
                errorjson: response.data.errors
              });
            }
            console.log(this.state.json);
          })
          .catch(async error => {
            let result = await common.checkErrorResponse(error);
            if (result === 1) {
              this.submit();
            }
          })
          .finally(fin => {
            this.props.spinnerHandler(false);
          })
      } else {
        this.setState({
          errorjson: errorsList
        })
      }
    } else {
      common.notifyMessage("Missing some required fields!", 1);
    }
  };

  render() {
    let row = [];
    if (this.state.json.length !== 0) {
      this.state.json.map((obj, index) => {
        row.push({
          index: index + 1,
          ...obj
        });
      })
    }

    let visitor_table_data = {columns: this.props.visitors_offline_col, rows: row};
    let error_visitor_table_data = {columns: this.props.visitors_offline_errors_lists, rows: this.state.errorjson};

    return (
      <MDBModal isOpen={true} toggle={() => {
      }} size="lg">
        <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Offline System Access</MDBModalHeader>
        <MDBModalBody>
          <p className={"offline-warning-txt"}>(Download the <a href={csvFormat}>csv_format.csv</a> file. Modify the
            contents and upload)</p>
          <div style={{display: "inline-flex"}}>
            <Files
              className='files-dropzone'
              onChange={this.onFilesChange("file")}
              accepts={["text/csv", ".csv"]}
              multiple={false}
              maxFileSize={10000000}
              minFileSize={0}
              clickable
            >
              <button className={"file-uploader"}>Choose CSV file&nbsp;&nbsp;
                <Icon name={"upload"}/>
              </button>
            </Files>
            {
              this.state.json.length !== 0 && !this.state.isSpin ? <div style={{margin: 'auto'}}>
                  <SementicBtn className="px-5 offline-submit" onClick={this.submit}>Submit</SementicBtn>
                  <SementicBtn onClick={this.removeData} className={"offline-remove-btn"} icon='trash alternate'/>
                </div>
                : null
            }

          </div>
          {
            this.state.errorjson.length !== 0 ?
              <Row className={"none-margin"}>
                <Col xs={12} className={"offline-error-title"}>
                  Errors at some rows
                </Col>
                <Col xs={12} className={"none-padding"}>
                  <MDBDataTable
                    id={"visitors-error-offline"}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    paging={true}
                    entriesOptions={[5, 10, 20, 50]}
                    entries={5}
                    searching={false}
                    bordered
                    hover
                    data={error_visitor_table_data}/>
                </Col>
                <br/><br/>
              </Row> : null
          }
          <Row>
            {
              this.state.json.length !== 0 && !this.state.isSpin ?
                <Col>
                  <MDBDataTable
                    id={"visitors-offline"}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    paging={true}
                    searching={false}
                    bordered
                    hover
                    data={visitor_table_data}/>
                </Col> : null
            }
            {
              this.state.isSpin ? <Spin/> : null
            }

          </Row>
        </MDBModalBody>
      </MDBModal>
    );
  }
}

function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

const mapStateToProps = (state) => ({
  visitors_offline_col: state.reception_SheduleMeetingReducer.visitors_offline_col,
  visitors_offline_errors_lists: state.reception_SheduleMeetingReducer.visitors_offline_errors_lists,
  visitors: state.viewAllCheckIN.visitors,
  checkInVisitors: state.viewAllCheckIN.checkInVisitors,
  historyColumns: state.viewAllCheckIN.historyColumns,
  column: state.viewAllCheckIN.column,

  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
